import Gumshoe from 'gumshoejs';

const fakeTabs = document.querySelector('.fake-tabs');
if (fakeTabs) {
  new Gumshoe('.fake-tabs a', {
    reflow: true,
    navClass: 'is-active',
	  contentClass: 'is-active',
    offset: function () {
      return fakeTabs.clientHeight + 60;
    },
    events: false
  });
}
